import { gql } from '@apollo/client'

export const ConclusionModalObjectiveFragment = gql`
  fragment ConclusionModalObjectiveFragment on ObjectiveDTO {
    id
    globalId
    title
    due
    start
    status
    targetAmount
    achievedAmount
    currency
    attachment
    closedDate
    keyResults {
      id
      text
      completed
      globalId
    }
    noteList {
      id
      text
      date
      author {
        id
        firstName
        lastName
      }
    }
    appraisalSeason {
      id
      companyId
      country
      year
      fromDate
      toDate
    }
  }
`
